import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, API } from "../../../api";
import * as dateFns from "date-fns";
import Typography from "@material-ui/core/Typography";

export default function SalesReturnDetails() {
  const [getReport, { data, loading }] = useLazyQuery(
    API.GET_SALES_RETURN_DETAILS,
    { fetchPolicy: "network-only" }
  );

  const [filters, setFilters] = React.useState({
    startDate: dateFns.startOfMonth(new Date()),
    endDate: dateFns.endOfMonth(new Date()),
  });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const onDateRangeChange = ({ startDate, endDate }) => {
    setFilters({ ...filters, startDate, endDate });
  };

  const getStatus = (row) => {
    const { netTotal, dueAmount } = row;
    let value = "Unpaid";
    if (dueAmount > 0.01 && dueAmount < netTotal) {
      value = "Partial";
    } else if (dueAmount < 0.01) {
      value = "Paid";
    }
    if (netTotal < 0.01) {
      value = "Returned";
    }
    return value;
  };

  const renderStatus = (value) => {
    let color = "#EE4123";
    if (value === "NORMAL") {
      color = "#4CAF50";
    }
    return (
      <Typography style={{ color, fontSize: 13 }} variant="button">
        {value?.toUpperCase()}
      </Typography>
    );
  };

  const getData = () => {
    if (!data) return [];
    return data.map((t) => ({ ...t, status: getStatus(t) }));
  };

  const columns = [
    {
      name: "date",
      label: "Sales Return Date",
      options: { align: "center", date: true },
    },
    {
      name: "salesReturnNo",
      label: "Sales Return #",
      options: { align: "center" },
    },
    {
      name: "customer.name",
      label: "Customer Name",
      options: { align: "left", width: 400 },
    },
    {
      name: "netTotal",
      label: "Total",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "type",
      label: "Type",
      options: {
        align: "center",
        customBodyRender: (v) => renderStatus(v),
      },
    },
  ];

  return (
    <Report
      title="Sales Return Details"
      useDateRange
      onDateRangeChange={onDateRangeChange}
      startDate={filters?.startDate}
      endDate={filters?.endDate}
      data={getData()}
      columns={columns}
      filters={[
        {
          type: "range",
          name: "range",
          label: "Sales Return Number Range",
          value: filters?.range,
        },
      ]}
      onFiltersChange={(e) => setFilters((x) => ({ ...x, ...e }))}
    >
      <Table
        data={getData()}
        columns={columns}
        showTotals
        isLoading={loading}
      />
    </Report>
  );
}
